let modelViewerLoaderPromise = null

export const ensureModelViewer = () => {
  if (typeof window === 'undefined') {
    return Promise.resolve()
  }

  if (customElements.get('model-viewer')) {
    return Promise.resolve()
  }

  if (!modelViewerLoaderPromise) {
    modelViewerLoaderPromise = import('@google/model-viewer')
      .then(() => customElements.whenDefined('model-viewer'))
      .catch((error) => {
        modelViewerLoaderPromise = null
        throw error
      })
  }

  return modelViewerLoaderPromise
}
